<!-- Copyright (c) 2021 VMware, Inc. All rights reserved. VMware Confidential -->
<div class="item-wrapper">
    <ng-content></ng-content>
</div>
<ng-content select="summary-grid-total"></ng-content>
